import { Spinner } from '@ntconsult/aluma-react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks';
import { consumeRedirect } from '../utils/redirectAfterLogin';

/**
 * Aterrissagem do callback OIDC (SPEC 1.1 / 1.4). O back já trocou o code e emitiu
 * os cookies, redirecionando para cá com `?success=1`. Aqui só revalidamos `GET /me`
 * (a query tem staleTime 0, então refetcha) e seguimos para o destino salvo.
 * Erro/conta inativa caem em `/login?error=...` direto do back — não passam por aqui.
 */
export function AzureCallback() {
  const [params] = useSearchParams();
  const { isAuthenticated, isLoading } = useAuth();

  if (params.get('success') !== '1') {
    return <Navigate to="/login?error=auth_failed" replace />;
  }
  if (isLoading) return <Spinner layout="fullPage" />;
  if (isAuthenticated) return <Navigate to={consumeRedirect() ?? '/'} replace />;
  return <Navigate to="/login?error=auth_failed" replace />;
}
